import { render, staticRenderFns } from "./ta-IN.vue?vue&type=template&id=27853c18&"
import script from "./ta-IN.vue?vue&type=script&lang=js&"
export * from "./ta-IN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27853c18')) {
      api.createRecord('27853c18', component.options)
    } else {
      api.reload('27853c18', component.options)
    }
    module.hot.accept("./ta-IN.vue?vue&type=template&id=27853c18&", function () {
      api.rerender('27853c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/ta-IN.vue"
export default component.exports